import { PortableText } from '@portabletext/react'
import type { InferGetServerSidePropsType, GetServerSideProps } from 'next'
import { useLiveQuery } from '~/lib/sanity-live-query'
import { getGlobalData } from '../../utils/global-data';
import Footer from '../../components/Footer';
import Layout from '../../components/Layout';
import SEO from '../../components/SEO';
import StickyNavbar from '../../components/StickyNavbar';
import HorizontalLine from '../../components/HorizontalLine';
import SliderTimber from '../../components/Sliders/SliderTimber';
import SliderCategory from '../../components/Sliders/SliderCategory';

import { readToken } from '~/lib/sanity.api'
import { getClient } from '~/lib/sanity.client'
import {
  getCategory,
  getCategories,
  getSiteConfig,
  categoryBySlugQuery,
  categoriesQuery,
  siteConfigQuery,
} from '~/lib/sanity.queries'
import { type SiteConfig, Category } from '~/lib/sanity.interfaces'
import type { SharedPageProps } from '~/pages/_app'
import CarouselTitle from "~/components/CarouselTitle/CarouselTitle";
import ModuleList from '~/components/ModuleList';
import Link from 'next/link';


  interface Query {
    [key: string]: string
  }
  
  export const getServerSideProps: GetServerSideProps<
    SharedPageProps & {
      category: Category,
      categories: Category[],
      siteConfig: SiteConfig,
    },
    Query
  > = async ({ draftMode = false, params = {} }) => {
    const client = getClient(draftMode ? { token: readToken } : undefined)
    const category = await getCategory(client, params.slug)
    const categories = await getCategories(client)
    const siteConfig = await getSiteConfig(client)
    const globalData = getGlobalData()
  
    if (!category) {
      return {
        notFound: true,
      }
    }
  
    return {
      props: {
        globalData,
        draftMode,
        token: draftMode ? readToken : '',
        category,
        categories,
        siteConfig,
      },
    }
  }

export default function CategoryPage(
  props: InferGetServerSidePropsType<typeof getServerSideProps>,
  globalData
) {
  const [category] = useLiveQuery(props.draftMode, props.category, categoryBySlugQuery, {
    slug: props.category.slug.current,
  })
  const [categories] = useLiveQuery<Category[]>(props.draftMode, props.categories, categoriesQuery)
  const [siteConfig] = useLiveQuery(props.draftMode, props.siteConfig, siteConfigQuery)

  const slides = []
  if(category.mainCarousel) {
    category.mainCarousel.map((item) => {
      slides.push({
        _id: item._id,
        image: item,
        title: item.title
      });
    })
  }
  
  return (
    <Layout>
        <SEO title={category.seoTitle} description={category.seoDescription} keywords={category.seoKeywords} />
        <StickyNavbar siteConfig={siteConfig} />
        <main className="w-full bg-background nav-offset py-8">     
            <div className='mx-2 md:mx-10'>
                <div className='mb-10'>
                  <CarouselTitle slides={slides} />
                </div>
                <div className='contentBlock text-left text-lg'>
                  <PortableText value={category.body} />
                </div>
                <HorizontalLine />                
            </div>
            {category.pageModules && (
              <div className='mx-2 md:mx-10'>
                <ModuleList moduleList={category.pageModules} />
              </div> 
            )}
            {category.selectedTimbers && ( 
              <div className='mx-8'>
                <div className="text-right">
                    <h3 className="text-4xl font-semibold text-primary mb-10">Available Timbers</h3>
                </div>                 
                <SliderTimber timbers={category.selectedTimbers} />
                <div className='flex justify-end'>
                  <Link className="mt-2 font-bold underline" href="/timbers">See all Timber Species</Link>
                </div>
                <HorizontalLine />
                </div>
            )}              
            {/* <div>                
                <HorizontalLine />
                <div className='contentBlock text-left text-lg mx-10'>
                  <PortableText value={category.bodysecond} />
                </div>
            </div> */}
            {category.selectedSystems && (  
            <div className='mx-2 md:mx-10'>
                <div className="text-right">
                    <h3 className="text-4xl font-semibold text-primary mb-10">Timber Systems</h3>
                </div> 
                <SliderCategory items={category.selectedSystems} prefix="/systems/" />
                <HorizontalLine />
            </div>  
             )} 
             {category.selectedProducts && (  
            <div className='mx-2 md:mx-10'>
                <div className="text-right">
                    <h3 className="text-4xl font-semibold text-primary mb-10">Products</h3>
                </div> 
                <SliderCategory items={category.selectedProducts} prefix="/systems/" />
                <HorizontalLine />
            </div>  
             )}
              
            <div className='mx-2 md:mx-10'>
                <div className="text-right">
                    <h3 className="text-4xl font-semibold text-primary mb-10">Other Applications</h3>
                </div> 
                <SliderCategory items={categories} prefix="/categories/" />
            </div>   
            </main>        
        <Footer siteConfig={siteConfig} />      
    </Layout>
  );
}


